import type * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import type { ComponentPropsWithoutRef, ComponentRef, ReactNode } from "react";

import type { DefinedDefaults } from "@/ui/lib";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const RADIO_GROUP_OPTION_VARIANT_CLASS_MAP = {
  default: "inset-shadow-sm-inverse has-[button[data-state=checked]]:inset-shadow-sm",
  boxed: "transition-colors ease-in-out duration-200 border border-solid border-component-checkbox-variant-boxed-unchecked has-[button[data-state=checked]]:border-component-radio-variant-boxed-checked has-[button[data-state=checked]]:bg-component-checkbox-check-checked has-[button[data-state=checked]]:text-foreground-inverse",
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TRadioGroupVariant = keyof typeof RADIO_GROUP_OPTION_VARIANT_CLASS_MAP;

export type TRadioGroupOption = {
  description?: ReactNode;
  disabled?: boolean;
  label: ReactNode;
  value: string;
};

export type TRadioGroupElement = ComponentRef<typeof RadioGroupPrimitive.Root>;
export type TRadioGroupItemElement = ComponentRef<typeof RadioGroupPrimitive.Item>;
export type TRadioGroupItemProps = ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>;
export type TRadioGroupIndicatorElement = ComponentRef<typeof RadioGroupPrimitive.Indicator>;
export type TRadioGroupIndicatorProps = ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Indicator>;
export type TRadioGroupProps = ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> & {
  error?: string;
  label: string;
  options: TRadioGroupOption[];
  variant?: TRadioGroupVariant;
  hideLabel?: boolean;
};

type TRadioGroupDefaultProps = DefinedDefaults<
  TRadioGroupProps,
  "variant"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const RADIO_GROUP_DEFAULTS = {
  variant: "default",
} satisfies TRadioGroupDefaultProps;
